// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/Amadeus/insa-kendo-css/kendo.custom.css
// module id = 1850
// module chunks = 2